import { render, staticRenderFns } from "./CouponCodeEdit.vue?vue&type=template&id=53bb871a&"
import script from "./CouponCodeEdit.vue?vue&type=script&lang=js&"
export * from "./CouponCodeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports